import React, { useState, useEffect, useRef, forwardRef } from "react";
import { auth } from "../../services/firebase";
import CalendarModal from "../CalendarModal";
import { ReactComponent as TaskIcon } from '../../assets/icons/TaskIcon.svg'
import { ReactComponent as DeleteIcon } from '../../assets/icons/DeleteIcon.svg'
import { ReactComponent as StarIcon } from '../../assets/icons/StarIcon.svg'
const LoadingSpinner = () => (
  <div className="sidebar-spinner-overlay">
    <div className="sidebar-spinner"></div>
  </div>
);
const TareasSideBar = forwardRef(({ isVisible, onClose }, ref) => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isCalendarModalVisible, setIsCalendarModalVisible] = useState(false);
  const [newTask, setNewTask] = useState({
    title: "",
    details: "",
    date: null,
  });
  const [tareas, setTareas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);
  const sidebarClass = `general-sidebar ${isVisible ? "visible" : ""}`;
  const fetchTareas = async () => {
    setIsLoading(true);
    try {
      const user = auth.currentUser;
      if (!user) return;
      const idToken = await user.getIdToken();
      const res = await fetch(`https://backend-288175208699.europe-west1.run.app/api/tareas?uid=${user.uid}`, { headers: { Authorization: `Bearer ${idToken}` } });
      const data = await res.json();
      if (res.ok) {
        setTareas(data);
      } else {
        console.error("❌ Error al obtener tareas:", data.error);
      }
    } catch (error) {
      console.error("❌ Error de conexión:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const guardarTareaEnBackend = async (task) => {
    setIsLoading(true);
    try {
      const user = auth.currentUser;
      if (!user) return;
      const idToken = await user.getIdToken();
      const res = await fetch("https://backend-288175208699.europe-west1.run.app/api/tareas", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
        body: JSON.stringify({
          uid: user.uid,
          title: task.title,
          details: task.details,
          date: task.date.toISOString(),
        }),
      });
      if (res.ok) {
        await fetchTareas();
      }
    } catch (error) {
      console.error("❌ Error al guardar tarea:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (isVisible) {
      fetchTareas();
    }
  }, [isVisible]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTask((prev) => ({ ...prev, [name]: value }));
  };
  const handleTodayClick = () => {
    setNewTask((prev) => ({ ...prev, date: new Date() }));
  };
  const handleTomorrowClick = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    setNewTask((prev) => ({ ...prev, date: tomorrow }));
  };
  const handleCalendarClick = () => setIsCalendarModalVisible(true);
  const handleCloseCalendarModal = () => setIsCalendarModalVisible(false);
  const handleDateSelect = (date) => {
    setNewTask((prev) => ({ ...prev, date }));
    setIsCalendarModalVisible(false);
  };
const toggleDone = async (task) => {
  try {
    const user = auth.currentUser;
    if (!user) return;
    const idToken = await user.getIdToken();

    // ✅ Primero marcamos la tarea como "done" en el estado local
    setTareas((prev) =>
      prev.map((t) =>
        t.createdAt === task.createdAt ? { ...t, done: true } : t
      )
    );

    // ⏳ Esperamos medio segundo antes de eliminarla
    setTimeout(async () => {
      // Llamada al backend para borrar definitivamente
      const res = await fetch("https://backend-288175208699.europe-west1.run.app/api/tareas/delete", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
        body: JSON.stringify({
          uid: user.uid,
          createdAt: task.createdAt,
        }),
      });

      const data = await res.json();
      if (res.ok) {
        setTareas(data.tareas); // Actualizamos lista con el backend
      } else {
        console.error("❌ Error al eliminar tarea:", data.error);
      }
    }, 500);
  } catch (error) {
    console.error("❌ Error en toggleDone:", error);
  }
};
  const deleteTask = async (task) => {
    setIsLoading(true);
    try {
      const user = auth.currentUser;
      if (!user) return;
      const idToken = await user.getIdToken();
      const res = await fetch("https://backend-288175208699.europe-west1.run.app/api/tareas/delete", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
        body: JSON.stringify({
          uid: user.uid,
          createdAt: task.createdAt,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        setTareas(data.tareas);
      } else {
        console.error("❌ Error al eliminar tarea:", data.error);
      }
    } catch (error) {
      console.error("❌ Error de conexión al eliminar tarea:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const toggleFavorite = async (task) => {
    setIsLoading(true);
    try {
      const user = auth.currentUser;
      if (!user) return;
      const idToken = await user.getIdToken();
      const res = await fetch("https://backend-288175208699.europe-west1.run.app/api/tareas/favorite", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
        body: JSON.stringify({
          uid: user.uid,
          createdAt: task.createdAt,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        setTareas(data.tareas);
      } else {
        console.error("❌ Error al actualizar favorito:", data.error);
      }
    } catch (error) {
      console.error("❌ Error de conexión al actualizar favorito:", error);
    } finally {
      setIsLoading(false);
    }
  };

    const formatTaskDate = (date) => {
    if (!date) return "Sin fechas";

    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const isToday =
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate();

    const isTomorrow =
      date.getFullYear() === tomorrow.getFullYear() &&
      date.getMonth() === tomorrow.getMonth() &&
      date.getDate() === tomorrow.getDate();

    if (isToday) {
      return "Hoy";
    }

    if (isTomorrow) {
      return "Mañana";
    }

    const days = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
    const months = [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sept",
      "oct",
      "nov",
      "dic",
    ];

    const dayName = days[date.getDay()];
    const dayNum = date.getDate();
    const month = months[date.getMonth()];

    // Formato "Vie, 19 sept"
    let label = `${dayName}, ${dayNum} ${month}`;
    // Poner la primera letra en mayúscula si es necesario
    label = label.charAt(0).toUpperCase() + label.slice(1);
    
    return label;
  };

  return (
    <div className={sidebarClass} ref={ref} style={{gap:'0'}}>
         {isLoading && <LoadingSpinner />}
      <div className="sidebar-header" style={{paddingBottom:'10px'}}>
        <h2 className="sidebar-header-title">Tareas</h2>
        <div className="sidebar-header-actions">
          <button onClick={onClose} className="sidebar-close-button">
            &times;
          </button>
        </div>
      </div>
      <div onClick={() => setIsFormVisible(!isFormVisible)} className="add-task-button">
        + Agregar tarea
      </div>
      {isFormVisible && (
        <>
         <p className="selected-date">
  {formatTaskDate(newTask.date)}
</p>
<div className="task-form-container" ref={formRef}>
  <input
    type="text"
    name="title"
    placeholder="Título"
    value={newTask.title}
    onChange={handleInputChange}
    className="task-input"
  />
  <input
    name="details"
    placeholder="Detalles"
    value={newTask.details}
    onChange={handleInputChange}
    className="task-textarea"
  />
  <div className="task-date-buttons">
  <button 
    onClick={handleTodayClick} 
    className={`date-button today-button ${newTask.date && newTask.date.toDateString() === new Date().toDateString() ? 'selected-button' : ''}`}
  >
    Hoy
  </button>
  <button 
    onClick={handleTomorrowClick} 
    className={`date-button tomorrow-button ${newTask.date ? newTask.date.toDateString() === new Date(new Date().setDate(new Date().getDate() + 1)).toDateString() ? 'selected-button' : '' : ''}`}
  >
    Mañana
  </button>
  <button 
    onClick={handleCalendarClick} 
    className={`date-button calendar-button ${newTask.date && newTask.date.toDateString() !== new Date().toDateString() && newTask.date.toDateString() !== new Date(new Date().setDate(new Date().getDate() + 1)).toDateString() ? 'selected-button' : ''}`}
  >
    <TaskIcon className="date-button-icon"/>
  </button>
<button
  onClick={() => {
    if (newTask.title && newTask.date) {
      guardarTareaEnBackend({
        ...newTask,
        details: newTask.details || "",
      });
      setIsFormVisible(false);
      setNewTask({ title: "", details: "", date: null });
    }
  }}
  className="save-task-button"
  disabled={!newTask.title || !newTask.date}  // 🔹 Aquí lo deshabilitamos
>
  Guardar
</button>
  </div>
</div>
        </>
      )}
<div
  className="task-list"
  style={{ marginTop: isFormVisible ? "10px" : "0" }}
>
  {tareas.length > 0 ? (
    Object.entries(
      [...tareas]
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .reduce((groups, task) => {
          const dateKey = new Date(task.date).toISOString().slice(0, 10);
          if (!groups[dateKey]) groups[dateKey] = [];
          groups[dateKey].push(task);
          return groups;
        }, {})
    ).map(([dateISO, tasks]) => {
      const today = new Date();
      const todayISO = today.toISOString().slice(0, 10);
      const tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);
      const tomorrowISO = tomorrow.toISOString().slice(0, 10);
      let label = dateISO;
      if (dateISO === todayISO) label = "Hoy";
      else if (dateISO === tomorrowISO) label = "Mañana";
      else {
        const dateObj = new Date(dateISO);
        label = dateObj.toLocaleDateString("es-ES", {
          weekday: "short",
          day: "numeric",
          month: "short",
        });
        label = label.charAt(0).toUpperCase() + label.slice(1);
      }
      return (
        <div key={dateISO} className="task-day-group">
          <div className={`task-date ${label === "Hoy" ? "today" : ""}`}>{label}</div>
          {tasks.map((t, i) => (
<div className={`task-item ${t.done ? "done" : ""}`} key={i}>
  <div className="task-content">
    <button
      className={`check-circle ${t.done ? "done" : ""}`}
      onClick={() => toggleDone(t)}
    />
  <div className="task-info">
    <h4 className={t.done ? "task-done" : ""}>{t.title}</h4>
    <p className={t.done ? "task-done" : ""}>{t.details}</p>
    {t.date && (
      <small className="task-time">
        {new Date(t.date).toLocaleTimeString("es-ES", {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </small>
    )}
  </div>
<div className="task-icons">
  <DeleteIcon className="delete-task-button" onClick={() => deleteTask(t)} />
      <StarIcon
    className={`star-icon ${t.favorite ? "favorited" : ""}`}
    onClick={() => toggleFavorite(t)}
  />
</div></div>
            </div>
          ))}
        </div>
      );
    })
  ) : (
    <p className="no-tasks"></p>
  )}
</div>
      <CalendarModal
        isVisible={isCalendarModalVisible}
        onClose={handleCloseCalendarModal}
        onDateSelect={handleDateSelect}
        showTimeInput={true}
      />
    </div>
  );
});
export default TareasSideBar;